const isValidDate = (year: number, month: number, day: number): boolean => {
  const candidate = new Date(Date.UTC(year, month - 1, day));
  return (
    candidate.getUTCFullYear() === year &&
    candidate.getUTCMonth() === month - 1 &&
    candidate.getUTCDate() === day
  );
};

const formatDate = (year: number, month: number, day: number): string | null => {
  if (!isValidDate(year, month, day)) return null;
  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

/** Converts common OCR date formats to the form's ISO date value. */
export const normalizeBirthDate = (
  value: string | null | undefined,
): string | null => {
  if (!value) return null;
  const trimmed = value.trim();

  const iso = trimmed.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:T.*)?$/);
  if (iso) return formatDate(Number(iso[1]), Number(iso[2]), Number(iso[3]));

  const local = trimmed.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
  if (local)
    return formatDate(
      Number(local[3]),
      Number(local[2]),
      Number(local[1]),
    );

  return null;
};

/** Returns a valid digits-only Israeli identity number without padding guesses. */
export const normalizeIdentityNumber = (
  value: unknown,
): string | undefined => {
  if (value === null || value === undefined) return undefined;
  const digits = String(value).replace(/\D/g, '');
  return digits.length === 9 ? digits : undefined;
};

export const shouldReextractDriverLicense = (
  documentUrl: string | undefined,
  extraction:
    | { extractedIdNumber?: string; birthDate?: string | null }
    | undefined,
): boolean =>
  Boolean(documentUrl) &&
  !normalizeIdentityNumber(extraction?.extractedIdNumber) &&
  !normalizeBirthDate(extraction?.birthDate);
